import { render, staticRenderFns } from "./WavesBackground.vue?vue&type=template&id=5c81308e&scoped=true&"
import script from "./WavesBackground.vue?vue&type=script&lang=js&"
export * from "./WavesBackground.vue?vue&type=script&lang=js&"
import style0 from "./WavesBackground.vue?vue&type=style&index=0&id=5c81308e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c81308e",
  null
  
)

export default component.exports